import React, { useState } from "react";
import { Mail, Sparkles, Check } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const SUPABASE_URL = "https://dwxstxokyzmkoytpgcau.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR3eHN0eG9reXpta295dHBnY2F1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwNTA1NDksImV4cCI6MjA5MDYyNjU0OX0.GQAO_oLIpD0YbBkpu_lrT2LmNIyZ0Jk97WXO0fj8Kkw";

const EmailTrialForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      toast({ title: "E-mail invalido", description: "Digite um e-mail valido para comecar." });
      return;
    }
    setLoading(true);
    try {
      await fetch(`${SUPABASE_URL}/rest/v1/testadores_site`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "apikey": SUPABASE_ANON_KEY, "Authorization": `Bearer ${SUPABASE_ANON_KEY}`, "Prefer": "return=minimal" },
        body: JSON.stringify({ email: email, criado_em: new Date().toISOString() })
      });
      await fetch(`${SUPABASE_URL}/functions/v1/hyper-handler`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${SUPABASE_ANON_KEY}` },
        body: JSON.stringify({ action: "notify_new_tester", email: email })
      });
    } catch (err) { console.error("Erro:", err); }
    finally {
      setLoading(false);
      setSubmitted(true);
      toast({ title: "Recebemos seu e-mail!", description: "Em breve voce recebera o link de acesso." });
    }
  };

  if (submitted) {
    return (
      <div className={`flex items-center justify-center gap-2 ${compact ? "h-12" : "h-14"} px-5 rounded-full bg-emerald-500/15 border border-emerald-500/40`}>
        <Check className="w-5 h-5 text-emerald-300" />
        <span className="text-emerald-200 text-sm font-semibold">Recebemos! Link chegara para {email}</span>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md">
      <form onSubmit={handleSubmit} className="flex items-center gap-1.5 p-1.5 rounded-full bg-white/[0.04] border border-white/10 backdrop-blur-md w-full">
        <div className="flex items-center gap-2 flex-1 px-3">
          <Mail className="w-4 h-4 text-white/50 flex-shrink-0" />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@gmail.com (conta Google)" className="bg-transparent border-0 outline-none text-white placeholder:text-white/40 text-sm w-full h-10" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary-gradient flex items-center gap-1.5 px-5 h-11 rounded-full text-white font-semibold text-sm whitespace-nowrap border-0 disabled:opacity-60">
          <Sparkles className="w-4 h-4" />
          {loading ? "Enviando..." : "14 dias grátis"}
        </button>
      </form>
      <div className="mt-3">
        <p className="text-white/50 text-xs">
          Use o e-mail da sua conta Google cadastrada no celular Android.
          <button onClick={() => setShowHelp(!showHelp)} className="ml-1 text-blue-400 underline text-xs">
            {showHelp ? "Fechar" : "Como saber qual e?"}
          </button>
        </p>
      </div>
      {showHelp && (
        <div className="mt-3 rounded-xl overflow-hidden border border-white/10">
          <img src="/como_achar_email_google.png" alt="Como encontrar seu e-mail Google no Android" className="w-full" />
        </div>
      )}
    </div>
  );
};

export default EmailTrialForm;
